export class Pager {
    public resultSize: number = 0;
    public resultPage: number = 0;
    public resultCount: number = 0;
    public totalPages: number = 0;
}
